import styled from 'styled-components'
import { Image } from '@sainsburys-tech/bolt'

const WidgetContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px 0 16px 0;
`

const TextContainer = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
  align-self: center;
  margin-left: 6px;

  &:hover,
  &:active {
    cursor: pointer;
  }
`

const Link = styled.button`
  color: #016fba; // Matching Paypal widget which is uncustomisable, Will be replaced with theme token when we move all to our own payment component.

  text-decoration: underline;
  padding-left: 6px
  cursor: pointer;
  align-items: center;
  vertical-align: middle;
  display: inline-block;

  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  padding: 0;

  &:hover,
  &:active {
    cursor: pointer;
  }
`

const LabelImage = styled(Image)`
  margin-right: 10px;
  vertical-align: middle;
  cursor: pointer;
`

export { WidgetContainer, LabelImage, TextContainer, Link }
